/* Afroyla FALL CLEARANCE — personal 60-min access timer + soft SMS/email UTM gate + season end.
 * NOT a security gate: the duplicate PDPs stay reachable at their URL; this only controls this page's states.
 * States (mutually exclusive, root gets .is-<state>): gate (no utm + no stored access) → live (access valid,
 * < 60 min elapsed) → timesup (access expired — never restarts in this browser) → ended (after season end,
 * overrides all). Access = {start: epoch ms} written to localStorage AND a first-party cookie (45-day expiry) on
 * first grant so reloads/new tabs keep the same start. QA: ?fcnow=2026-10-02T12:00 (ET) shifts the clock,
 * ?fcreset=1 clears stored access. Needs window.AFC (afroyla-fall-clearance-core.js, loaded first). */
(function () {
  var A = window.AFC;
  if (!A) return;
  var root = A.root;

  // Client-side collection template → inject noindex (pattern: other Afroyla campaign sections)
  if (!document.querySelector('meta[name="robots"][data-afc-noindex]')) {
    var m = document.createElement('meta');
    m.name = 'robots'; m.content = 'noindex, nofollow';
    m.setAttribute('data-afc-noindex', '1');
    document.head.appendChild(m);
  }

  // ---- QA clock shift (?fcnow=2026-10-02T12:00, read as ET) ----
  var offset = 0;
  try {
    var q = new URLSearchParams(location.search).get('fcnow');
    if (q) {
      var iso = /T\d\d:\d\d$/.test(q) ? q + ':00-04:00' : /[+-]\d\d:\d\d$|Z$/.test(q) ? q : q + '-04:00';
      var t = Date.parse(iso);
      if (!isNaN(t)) offset = t - Date.now();
    }
  } catch (e) { /* ignore bad override */ }
  function now() { return Date.now() + offset; }

  var SEASON_END = Date.parse(root.dataset.seasonEnd);
  var ACCESS_MS = (Number(root.dataset.accessMinutes) || 60) * 60000;
  var KEY = 'afc_access_v1';

  function cookieGet(name) {
    var m2 = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m2 ? decodeURIComponent(m2[1]) : null;
  }
  function cookieSet(name, val) {
    document.cookie = name + '=' + encodeURIComponent(val) + '; expires=' + new Date(Date.now() + 45 * 86400000).toUTCString() + '; path=/; SameSite=Lax';
  }
  function cookieClear(name) { document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/'; }
  function readAccess() {
    var raw = null;
    try { raw = localStorage.getItem(KEY); } catch (e) { /* ignore */ }
    if (!raw) raw = cookieGet(KEY);
    var start = Number(raw);
    return raw && !isNaN(start) ? start : null;
  }
  function writeAccess(start) {
    try { localStorage.setItem(KEY, String(start)); } catch (e) { /* ignore */ }
    cookieSet(KEY, String(start));
  }
  function clearAccess() {
    try { localStorage.removeItem(KEY); } catch (e) { /* ignore */ }
    cookieClear(KEY);
  }
  try { if (new URLSearchParams(location.search).get('fcreset') === '1') clearAccess(); } catch (e) { /* ignore */ }

  var accessStart = readAccess();
  function utmGrants() {
    var p = new URLSearchParams(location.search).get('utm_source');
    return p === 'sms' || p === 'email';
  }
  if (accessStart == null && now() <= SEASON_END && utmGrants()) {
    accessStart = now();
    writeAccess(accessStart);
  }

  function phase() {
    if (now() > SEASON_END) return 'ended';
    if (accessStart == null) return 'gate';
    return now() < accessStart + ACCESS_MS ? 'live' : 'timesup';
  }

  var blocks = {
    gate: root.querySelector('[data-afc-gate]'),
    timesup: root.querySelector('[data-afc-timesup]'),
    ended: root.querySelector('[data-afc-ended]'),
    live: root.querySelectorAll('[data-afc-live]')
  };
  var lastPhase = '';
  function applyPhase(p) {
    if (p === lastPhase) return;
    lastPhase = p;
    root.className = root.className.replace(/\bis-\S+/g, '').trim() + ' is-' + p;
    if (blocks.gate) blocks.gate.hidden = p !== 'gate';
    if (blocks.timesup) blocks.timesup.hidden = p !== 'timesup';
    if (blocks.ended) blocks.ended.hidden = p !== 'ended';
    blocks.live.forEach(function (el) { el.hidden = p !== 'live'; });
    if (p === 'timesup') paintTimesUpCta();
    root.dispatchEvent(new CustomEvent('afc:phase', { detail: { phase: p } }));
  }
  // "Check out my cart" only shows if the cart actually has items (60-min items still checkout-able)
  function paintTimesUpCta() {
    var cta = root.querySelector('[data-afc-timesup-cta]');
    if (!cta) return;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      cta.hidden = !cart.item_count;
    }).catch(function () { cta.hidden = true; });
  }

  var timerEl = root.querySelector('[data-afc-timer]');
  function tick() {
    applyPhase(phase());
    if (lastPhase === 'live' && timerEl) timerEl.textContent = A.mmss(accessStart + ACCESS_MS - now()) + ' LEFT';
  }
  tick();
  setInterval(tick, 500);

  // Jump links: Horizon hijacks window.scrollTo — scrollIntoView is reliable
  root.addEventListener('click', function (e) {
    var a = e.target.closest('[data-afc-jump]');
    if (!a) return;
    var el = document.querySelector(a.getAttribute('href'));
    if (!el) return;
    e.preventDefault();
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  A.now = now;
  A.phase = phase;
  A.remainMs = function () { return accessStart == null ? 0 : accessStart + ACCESS_MS - now(); };
  A.lastFiveMin = function () { return phase() === 'live' && A.remainMs() <= 5 * 60000; };
})();
